import { SimpleModal, Box } from '@sequencehq/core-components'
import { FC } from 'react'
import { inflect } from 'inflection'
import { ARCHIVE_QUOTE_SIGNATURE_WARNING } from 'modules/common/modals/quotes/archiveQuote.constants'

type Props = {
  isOpen: boolean
  onClose: () => void
  count: number
  showSignatureWarning: boolean
  // Returning false keeps the dialog open (e.g. so a failed archive can be
  // retried in place).
  onSubmit: () => boolean | Promise<boolean>
}

export const ArchiveQuotesDialog: FC<Props> = ({
  isOpen,
  onClose,
  count,
  showSignatureWarning,
  onSubmit
}) => {
  const inflected = inflect('quote', count)

  return (
    <SimpleModal
      variant="dialog"
      data-testid="quotes.bulkActions.archive.dialog"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      title={`Archive ${count} ${inflected}`}
      submitButtonText="Archive"
      submittingButtonText="Archiving"
      isDestructive
      disableSubmitOnEnter
    >
      You're about to archive{' '}
      <Box as="strong">
        {count} {inflected}
      </Box>
      .{' '}
      {showSignatureWarning ? (
        <Box
          as="span"
          data-testid="quotes.bulkActions.archive.dialog.signatureWarning"
        >
          {ARCHIVE_QUOTE_SIGNATURE_WARNING}{' '}
        </Box>
      ) : null}
      You can still duplicate archived quotes.
    </SimpleModal>
  )
}
